/* eslint-disable no-unused-vars */

import PhotoDocumentSubSection from './photo-document-sub-section';
import UTSubsection from './cml-sub-section';
import AdditionalDataNotDownloadSubSection from './additional-data-not-download-sub-section';
import { store } from 'redux/store';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { WorkTypes } from '@components/work-order/helper';
const UtCmlContainer = ({
  utData,
  dropdownMenuMapList,
  setValue,
  getValues,
  name,
  errors,
  removeSpecialCharactersForName,
  field,
  appliesToDataEquipmentId,
  task
}) => {
  const { cache, utFormData, inspection } = store.getState();
  const { equipmentListThatHaveUTSection } = cache;
  const { utFormDataOfInspection = {} } = utFormData;
  const [searchParams] = useSearchParams();

  const { listOfInspectionFormThatHaveUTSection } = inspection;

  const newRecordId = searchParams.get('new-recordId') || '';
  const inspectionType = searchParams.get('inspectionType') || '';
  const workType = searchParams.get('type') || '';
  let orderIds = searchParams.get('orderIds') || '';
  const equipmentId = searchParams.get('equipmentId') || '';

  let isCurrentTaskHaveUTForm = useMemo(() => {
    let isCurrentTaskHaveUTForm = false;
    // assigned
    const isNewForm = [WorkTypes.NewInspection].includes(workType) && !orderIds ? true : false;
    if (!isNewForm) {
      if (task?.type === 'Inspection' && task?.equipmentId && task?.inspectionTypeId) {
        const hasUTDataDownload = utFormDataOfInspection[task?.inspectableItemId || task?.id]
          ? true
          : false;

        const isThisEquipmentIdIncludeOnUTS = equipmentListThatHaveUTSection?.includes(
          task.equipmentId
        );

        const isThisInspectionIdIncludeOnUTS = listOfInspectionFormThatHaveUTSection?.includes(
          task.inspectionTypeId?.toString()
        );

        isCurrentTaskHaveUTForm =
          !hasUTDataDownload && isThisEquipmentIdIncludeOnUTS && isThisInspectionIdIncludeOnUTS;
      }
    } else if (equipmentId && inspectionType && newRecordId) {
      const hasUTDataDownload = utFormDataOfInspection[newRecordId] ? true : false;
      const isThisEquipmentIdIncludeOnUTS = equipmentListThatHaveUTSection?.includes(equipmentId);

      const isThisInspectionIdIncludeOnUTS = listOfInspectionFormThatHaveUTSection?.includes(
        inspectionType?.toString()
      );

      isCurrentTaskHaveUTForm =
        !hasUTDataDownload && isThisEquipmentIdIncludeOnUTS && isThisInspectionIdIncludeOnUTS;
    }

    return isCurrentTaskHaveUTForm;
  }, [
    workType,
    orderIds,
    task,
    utFormDataOfInspection,
    equipmentListThatHaveUTSection,
    listOfInspectionFormThatHaveUTSection,
    inspectionType,
    appliesToDataEquipmentId,
    equipmentId,
    newRecordId
  ]);

  return (
    <div>
      <PhotoDocumentSubSection
        photos={utData?.photos}
        documents={utData?.documents}
        isImagesFailedDuringFetch={utData.imagesFailed}
      />
      {isCurrentTaskHaveUTForm && <AdditionalDataNotDownloadSubSection />}
      <UTSubsection
        dropdownMenuMapList={dropdownMenuMapList}
        setValue={setValue}
        getValues={getValues}
        name={name}
        errors={errors}
        baseName={removeSpecialCharactersForName}
        fieldId={field.formFieldId}
        appliesToDataEquipmentId={appliesToDataEquipmentId}
      />
    </div>
  );
};

export default UtCmlContainer;
